import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrlService } from '../shared-services/api-url.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WalletManagmentService {
  constructor(
    private readonly http: HttpClient,
    private readonly apiUrlService: ApiUrlService
  ) {}

  getWalletChart(params: { type: string; userRole: string; partnerId?: string; resellerId?: string}) {
    return this.http.get<{ data: WalletData }>(this.apiUrlService.GET_WALLET_CHART, {
      params,
    });
  }
  getCommissionChart(params: {userRole: string; partnerId?: string; resellerId?: string}) {
    return this.http.get<{ data: WalletData }>(this.apiUrlService.GET_WALLET_CHART, {
      params,
    });
  }
  updateWallet(payload: any,userId:any):Observable<any> {
  
    const url = `${this.apiUrlService.ADJUST_WALLET}/${userId}`;

    return this.http.put<any>(url, payload);
    
  }
}
export interface WalletData {
  _id: string,
  main: number;
  hold: number;
  manualHold: number;
  name: string;
  userId: string;
}